"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@xstate/react");
const react_2 = __importDefault(require("react"));
const Shimmer_1 = __importDefault(require("../../../components/Loading/Provider/Shimmer"));
const constants_1 = require("../../lib/constants");
const SwitchByState_1 = __importDefault(require("./SwitchByState"));
const messages_1 = __importDefault(require("../../lib/messages"));
const ErrorPage_1 = __importDefault(require("../../../components/ErrorPage/ErrorPage"));
const styles_1 = require("../../../components/LayoutFactory/styles");
const ManageAppointmentLayout_1 = __importDefault(require("../Layout/ManageAppointmentLayout"));
/**
 * Component for managing appointment container
 *
 * @param {ManageAppointmentProps} param Props
 */
const ManageAppointment = ({ service }) => {
    const [currentState] = (0, react_1.useService)(service);
    const { matches } = currentState;
    if (matches(constants_1.states.fetchingAppointment)) {
        return (react_2.default.createElement(styles_1.SimpleContainer, null,
            react_2.default.createElement(Shimmer_1.default, null)));
    }
    if (matches(constants_1.states.failedLoading)) {
        return (react_2.default.createElement(styles_1.SimpleContainer, null,
            react_2.default.createElement(ErrorPage_1.default, { bannerText: messages_1.default.failedToLoad })));
    }
    return (react_2.default.createElement(ManageAppointmentLayout_1.default, { service: service, shouldRenderSearchProviderButton: matches(constants_1.states.alreadyCanceled), renderChildren: (headerHeight, bodyIsAnimating) => {
            return (react_2.default.createElement(SwitchByState_1.default, { service: service, matches: matches, context: currentState.context, headerHeight: headerHeight, bodyIsAnimating: bodyIsAnimating }));
        } }));
};
exports.default = ManageAppointment;
//# sourceMappingURL=ManageAppointment.js.map